import clsx from 'clsx';

import { Skeleton } from '@gitbook/spine-react';

import { UserAvatarSkeleton } from '../Users';

export function CommentBoxSkeleton(props: { withReplies?: boolean; withInput?: boolean }) {
    const { withReplies = false, withInput = false } = props;

    return (
        <div
            className={clsx(
                'my-2 flex w-full flex-col items-start rounded-lg border-[0.5px] border-base border-solid bg-base text-start transition-all'
            )}
        >
            {/* Top half with comment and replies */}
            <div className="flex w-full flex-col p-4">
                {/* Comment header with avatar and name */}
                <div className="flex items-center gap-2">
                    <UserAvatarSkeleton size="sm" />
                    <div className="flex flex-col gap-1">
                        <Skeleton className="h-4 w-24" />
                        <Skeleton className="h-3 w-16" />
                    </div>
                </div>

                {/* Comment body */}
                <div className="mt-2.5 ml-8 flex flex-col gap-2">
                    <Skeleton className="h-5 w-full" />
                    <Skeleton className="h-5 w-1/2" />
                </div>

                {withReplies ? (
                    <>
                        {/* Replies section */}
                        <div className="mt-4 flex flex-col gap-2">
                            <div className="flex items-center gap-2">
                                <UserAvatarSkeleton size="sm" />
                                <div className="flex flex-col gap-1">
                                    <Skeleton className="h-3 w-20" />
                                    <Skeleton className="h-3 w-16" />
                                </div>
                            </div>
                            <Skeleton className="h-4 w-2/3" />
                        </div>
                    </>
                ) : null}
            </div>

            {/* Bottom reply input field */}
            {withInput ? (
                <div className="flex w-full border-base border-t-0.5">
                    <div className="flex w-full items-center gap-2 p-2">
                        <UserAvatarSkeleton size="sm" />
                        <Skeleton className="h-6 w-full" />
                    </div>
                </div>
            ) : null}
        </div>
    );
}
